/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersLogoutMutationResponse, PostUsersLogout400 } from '../entities/PostUsersLogout'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUsersLogoutUrl() {
  return `/users/logout` as const
}

/**
 * @description Выход из системы
 * @summary Выход из системы
 * {@link /users/logout}
 */
export async function postUsersLogout(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PostUsersLogoutMutationResponse, ResponseErrorConfig<PostUsersLogout400>, unknown>({
    method: 'POST',
    url: getPostUsersLogoutUrl().toString(),
    ...requestConfig,
  })
  return res.data
}